export default __webpack_public_path__ + "static/media/ConvectionImg.5d7393c3.jpg";